export default __webpack_public_path__ + "img/allergy-sulphites.ab287b98d1224db53e9a8fd4114da7ff.svg";